import Axios, { AxiosPromise, AxiosResponse } from 'axios';
import * as qs from 'querystring';

import { getDatabase, ref, update } from 'firebase/database';
import Environment from '../../utils/Environement';
import BaseApi from "../base/BaseApi";

export default class UbereatsApi extends BaseApi {

    public readonly isDev: boolean;
    public readonly isPopina: boolean;
    // private handleRetriveToken: (token: string) => Promise<void>;
    private token: string | undefined

    constructor(isDev: boolean = false, isPopina: boolean = true) {
        super("api.uber.com/");
        this.isDev = isDev;
        this.isPopina = isPopina;
        // this.handleRetriveToken = (token: string) => firebase.database().ref().child(`settings/ubereats`).update({ 'token_menu': token });
        this.token = undefined;
    }

    async handleRetriveToken(token: string): Promise<void> {
        const database = getDatabase()
        const reference = ref(database, 'settings/ubereats');
        await update(reference, { 'token_menu': token });
    }

    async getUbereatsStore(storeID: string): Promise<AxiosPromise<any>> {
        try {
            const header = this.header(await this.retriveBearerIfNeeded());
            const res = await this.getRequest(`v1/eats/stores/${storeID}`, header);
            return res;
        }
        catch (e: any) {
            if (e.code as string === "401" || e.code as string === "403") {
                this.token = undefined;
                return await this.getUbereatsMenu(storeID);
            } else {
                throw e;
            }
        }
    }

    async getUbereatsMenu(storeID: string): Promise<AxiosResponse<any>> {
        try {
            const header = this.header(await this.retriveBearerIfNeeded());
            const res = await this.getRequest(`v2/eats/stores/${storeID}/menus`, header);
            return res;
        }
        catch (e: any) {
            if (e.code as string === "401" || e.code as string === "403") {
                this.token = undefined;
                return await this.getUbereatsMenu(storeID);
            } else {
                throw e;
            }
        }
    }

    async updateUbereatsMenu(storeID: string, menu: any): Promise<AxiosResponse<any>> {
        try {
            const header = this.header(await this.retriveBearerIfNeeded());
            const res = await this.putRequest(`v2/eats/stores/${storeID}/menus`, header, menu);
            return res;
        }
        catch (e: any) {
            if (e.code as string === "401" || e.code as string === "403") {
                this.token = undefined;
                return await this.updateUbereatsMenu(storeID, menu);
            } else {
                throw e;
            }
        }
    }

    private header(token: string): any {
        return { 'authorization': `Bearer ${token}` };
    }

    private async retriveBearerIfNeeded(): Promise<string> {
        if (this.token !== null && this.token !== undefined) {
            return this.token;
        }
        const body = (this.isDev)
            ? (this.isPopina) ? devCredentials : devCredentials
            : (this.isPopina) ? prodCredentials : jaliaProdCredentials;
        const res = await Axios.post(proxy + 'login.uber.com/oauth/v2/token', qs.stringify(body), { headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'cressOrigin': true } });
        const token = res.data['access_token'] as string;
        if (this.handleRetriveToken !== null && this.handleRetriveToken !== undefined) {
            await this.handleRetriveToken(token);
            this.token = token;
        }
        return token;
    }
}

const devCredentials = {
    client_id: 'KTv2La6aiWcSn6aMINHCsfbbafVWvxGG',
    client_secret: 'JYPPWDD54eXsfNWOMqdARJogqXvDUZUkMtPPKETh',
    grant_type: 'client_credentials',
    scope: 'eats.store'
};

const prodCredentials = {
    client_id: 'FGKDyfIpU5GNFs6cb3CElP2R-mSOOqQR',
    client_secret: '_-xKIiQWVXpk02lpZbn0htHPX_wM49SRsNrlQScf',
    grant_type: 'client_credentials',
    scope: 'eats.store'
};

const jaliaProdCredentials = {
    client_id: "YHkbCWF_2RMX2D1jC9yllxxs8czeMw3c",
    client_secret: "lWXUPKHHhuZtzyn37kJdjMr3dKliIAtaXa18K0iN",
    grant_type: 'client_credentials',
    scope: 'eats.store'
};

// const jaliaDevCredentials = {
//     client_id: "JEBjSyT22Qgf3gaXvLdNiwfjxXw_a-p2",
//     client_secret: "blxMIXepnA6-kFtFmp7IqRTH9VBbsO2Q7TQ_4O0S",
//     grant_type: 'client_credentials',
//     scope: 'eats.store'
// }

const proxy = (Environment.isDev)
    ? (Environment.isPopina) ? "https://us-central1-popina-dev.cloudfunctions.net/api/proxy/" : "https://us-central1-jalia-dev.cloudfunctions.net/api/proxy/"
    : (Environment.isPopina) ? "https://us-central1-popina-prod.cloudfunctions.net/api/proxy/" : "https://us-central1-jalia-prod.cloudfunctions.net/api/proxy/";
